import type { IUserForm } from '@/components/users/UserFormModal.vue'
import client from '@/services/client'
import type { IRoleAll } from '@/types/RoleTypes'
import type {
  IUser,
  IUserList,
  IUpdatePasswordPayload,
} from '@/types/UserTypes'

import type { AxiosResponse } from 'axios'

const getCurrentUser = async (): Promise<AxiosResponse<IUser>> =>
  client.get<IUser>('/users/me')

const updateUserMe = async (lastName: string): Promise<AxiosResponse<IUser>> =>
  client.patch<IUser>(`/users/me`, { lastName })

const updatePassword = async (
  payload: IUpdatePasswordPayload
): Promise<AxiosResponse<IUser>> =>
  client.patch<IUser>(`/users/password`, payload)

const getAllUsers = async (): Promise<AxiosResponse<IUserList[]>> => {
  return client.get('/users')
}

const removeUser = async (user: IUserList): Promise<AxiosResponse<void>> => {
  return client.delete(`/users/${user.uuid}`)
}

const changeStatusUser = async (
  user: IUserList,
  newStatus: boolean
): Promise<AxiosResponse<IUserList>> => {
  return client.patch(`users/${user.uuid}/active-status`, {
    isActive: newStatus,
  })
}

const createUser = async (
  userForm: IUserForm
): Promise<AxiosResponse<IUserList>> => {
  return client.post(`users`, {
    firstName: userForm.firstName,
    lastName: userForm.lastName,
    email: userForm.email,
    roleUuid: userForm.roles?.uuid || null,
  })
}

const updateUser = async (
  uuid: string,
  userForm: IUserForm
): Promise<AxiosResponse<IUserList>> => {
  return client.patch(`users/${uuid}`, {
    firstName: userForm.firstName,
    lastName: userForm.lastName,
    email: userForm.email,
    roleUuid: userForm.roles?.uuid || null,
  })
}

const updateUserRole = async (
  uuid: string,
  role: IRoleAll
): Promise<AxiosResponse<IUserList>> => {
  return client.patch(`users/${uuid}/roles`, { roleUuid: role.uuid })
}

const cancelPendingEmailChange = async (
  uuid: string
): Promise<AxiosResponse<IUserList>> => {
  return client.delete(`users/${uuid}/pending-email`)
}

export const UserRepository = {
  getCurrentUser,
  updateUserMe,
  updatePassword,
  getAllUsers,
  removeUser,
  changeStatusUser,
  createUser,
  updateUser,
  updateUserRole,
  cancelPendingEmailChange,
}
